import {typed} from '../../../typed';

import {ASTNodeArgument} from './class';

/**
 * ASTNodeArgumentString constructor.
 */
@typed.decorate('ASTNodeArgumentString')
export class ASTNodeArgumentString extends ASTNodeArgument {
	constructor() {
		super();
	}
}
